module.exports = "/work-site/img/major_device.0cad8a69.png";